(function(){
  'use strict';

  angular.module('eclipseApp.checkout').directive('printReceipt', function(){
    return {
      restrict: 'E',
      replace: true,
      templateUrl: 'modules/checkout/views/print-receipt-directive.html'
    };
  });
})();
